import { z } from 'zod'

export const MarketplaceSchema = z.enum(['wildberries', 'yandex-market'])
export const GuardReasonSchema = z.enum([
  'variant_not_in_registry',
  'ambiguous_variant_match',
  'counterpart_publication_absent',
  'counterpart_publication_archived',
  'barcode_unallocated',
  'warehouse_unconfigured',
  'campaign_unconfigured',
  'order_line_sku_not_in_registry',
  'stock_guard.invalid_source_marketplace',
  'stock_guard.observation_transport',
  'stock_guard.observation_rate_limited',
  'stock_guard.observation_http',
  'stock_guard.observation_response_rejected',
  'stock_guard.mutation_transport_ambiguous',
  'stock_guard.mutation_rate_limited',
  'stock_guard.mutation_http',
  'stock_guard.mutation_response_rejected',
  'stock_guard.mutation_client_construction',
  'stock_guard.retry_exhausted',
  'stock_guard.ledger_conflict',
  'stock_guard.non_production',
  'stock_guard.emergency_override',
  'stock_guard.channel_disabled',
  'stock_guard.zeroed',
])

export const StockGuardSettingsSchema = z.object({
  environment: z.enum(['local', 'preview', 'production']),
  dryRun: z.boolean(),
  settings: z.object({
    zeroOnWildberries: z.boolean(),
    zeroOnYandex: z.boolean(),
    restoreOnWildberries: z.boolean(),
    restoreOnYandex: z.boolean(),
  }).strict(),
  permitted: z.object({
    zeroOnWildberries: z.boolean(),
    zeroOnYandex: z.boolean(),
  }).strict(),
  planSummary: z.object({
    ymarket: z.object({
      population: z.number().int().nonnegative(),
      unchanged: z.number().int().nonnegative(),
      unknownStatus: z.number().int().nonnegative(),
      offerUnresolved: z.record(z.string(), z.number().int().nonnegative()),
      providerUnreadable: z.number().int().nonnegative(),
      blockedMutationsDisabled: z.number().int().nonnegative(),
      blockedForcedDryRun: z.number().int().nonnegative(),
      blockedSwitchOff: z.number().int().nonnegative(),
      writeZero: z.number().int().nonnegative(),
      writeOne: z.number().int().nonnegative(),
      notReached: z.number().int().nonnegative(),
      nextCursor: z.string().nullable(),
      lastRunAt: z.string().datetime().nullable(),
      digest: z.string().nullable(),
    }).strict(),
    wildberries: z.object({
      population: z.number().int().nonnegative(),
      unchanged: z.number().int().nonnegative(),
      unknownStatus: z.number().int().nonnegative(),
      offerUnresolved: z.record(z.string(), z.number().int().nonnegative()),
      providerUnreadable: z.number().int().nonnegative(),
      blockedMutationsDisabled: z.number().int().nonnegative(),
      blockedForcedDryRun: z.number().int().nonnegative(),
      blockedSwitchOff: z.number().int().nonnegative(),
      writeZero: z.number().int().nonnegative(),
      writeOne: z.number().int().nonnegative(),
      notReached: z.number().int().nonnegative(),
      nextCursor: z.string().nullable(),
      lastRunAt: z.string().datetime().nullable(),
      digest: z.string().nullable(),
    }).strict(),
  }).strict(),
}).strict()

export type Marketplace = z.infer<typeof MarketplaceSchema>
export type StockGuardSettings = z.infer<typeof StockGuardSettingsSchema>
